import axios from '../axios';

const fetchFlows = async (botId: string) => {
  const { data } = await axios.get(`/flows/${botId}`);

  return data;
};

export default fetchFlows;
